import React from "react";
import BaseModal from "./BaseModal";

/**
 * DeleteConfirmModal Component
 * Confirmation dialog for deleting items
 * Props:
 * - isOpen: Boolean to control visibility
 * - onClose: Callback when modal should close
 * - onConfirm: Callback when delete is confirmed
 * - isDeleting: Loading state for delete action
 * - itemName: Name of item being deleted (for display)
 * - warningText: Optional warning message
 */
export default function DeleteConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  isDeleting,
  itemName,
  warningText = "This action cannot be undone.",
}) {
  const footer = (
    <>
      <button
        className="cd-modal-btn cd-modal-btn-cancel"
        onClick={onClose}
      >
        Cancel
      </button>
      <button
        className="cd-modal-btn cd-modal-btn-delete"
        onClick={onConfirm}
        disabled={isDeleting}
      >
        {isDeleting ? "Deleting..." : "Delete"}
      </button>
    </>
  );

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Template"
      footer={footer}
    >
      <p>Are you sure you want to delete "<strong>{itemName}</strong>"?</p>
      <p className="cd-warning-text">{warningText}</p>
    </BaseModal>
  );
}
